import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Cake, Award, X } from "lucide-react";

const CONFETTI = ["#f472b6", "#a78bfa", "#fbbf24", "#34d399", "#60a5fa"];

export function CelebrationBanner() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [hidden, setHidden] = useState(false);
  const key = `celebration-dismissed-${user?.id}-${new Date().toLocaleDateString("en-CA")}`;
  useEffect(() => {
    if (localStorage.getItem(key)) { setHidden(true); return; }
    api.get("/staff-mgmt/my-celebration").then((r) => setItems(r.data)).catch(() => {});
  }, [key]);
  if (hidden || !items.length) return null;
  const first = (user?.name || "").split(" ")[0];
  return (
    <div className="px-4 sm:px-6 lg:px-10 mt-4 space-y-3">
      {items.map((x) => {
        const bday = x.kind === "birthday";
        return (
          <div key={x.kind} data-testid={`celebration-banner-${x.kind}`} className={`relative overflow-hidden rounded-2xl p-5 sm:p-6 text-white shadow-lg animate-in fade-in slide-in-from-top-2 duration-500 ${bday ? "bg-gradient-to-r from-pink-500 to-violet-600" : "bg-gradient-to-r from-amber-500 to-violet-600"}`}>
            {Array.from({ length: 14 }, (_, i) => (
              <span key={i} className="absolute rounded-full opacity-70 animate-pulse" style={{ width: 6 + (i % 3) * 3, height: 6 + (i % 3) * 3, background: CONFETTI[i % 5], left: `${(i * 7.3) % 100}%`, top: `${(i * 23) % 90}%`, animationDelay: `${i * 0.15}s` }} />
            ))}
            <div className="relative flex items-center gap-4">
              <div className="h-14 w-14 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center shrink-0">{bday ? <Cake size={28} /> : <Award size={28} />}</div>
              <div className="flex-1">
                <div className="font-display text-2xl sm:text-3xl font-extrabold">{bday ? `Happy Birthday, ${first}!` : `Happy ${x.years}-year Work Anniversary, ${first}!`}</div>
                <div className="text-white/90 text-sm mt-1">{bday ? "Wishing you a joyful day from everyone at SPARKORA." : `Thank you for ${x.years} wonderful year${x.years > 1 ? "s" : ""} with the SPARKORA family.`}</div>
              </div>
              <button data-testid={`celebration-banner-close-${x.kind}`} onClick={() => { localStorage.setItem(key, "1"); setHidden(true); }} className="self-start p-1 rounded-full hover:bg-white/20"><X size={18} /></button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
